<template>
    <list-container :columns="columns" :data="items" :actions="actions" titleKey="client"
        :headerActitonStyle="headerActitonStyle" @loadMore="$emit('loadMore')">
        <template #col-aging="{ row }">

            {{ row.aging }} Hrs.


        </template>
        <template #col-shipped="{ row }">

            {{ renderDate(row.shipped) }}


        </template>
        <template #col-approved="{ row }">

            <strong :class="row.approved == '1' ? 'custom-success' : 'custom-warning'">
                {{ row.approved == '1' ? 'Approved' : 'Pending' }}
            </strong>

        </template>


        <template #col-pre_total="{ row }">

            <strong>{{ formatCurrency(row.pre_total, 'USD') }}</strong>


        </template>
        <template #col-total="{ row }">

            <strong>{{ formatCurrency(row.total, 'USD') }}</strong>

        </template>

    </list-container>
</template>

<script>

import ListContainer from '@/views/app/components/containers/ListContainer.vue';
import { formatCurrency, renderDate } from '@/utils/helpers'
export default {
    name: 'ExpensesTable',
    components: { ListContainer },
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            columns: [
                { key: 'client', label: 'client' },
                { key: 'folio', label: 'folio' },
                { key: 'entry_id', label: 'entry_id' },
                { key: 'aging', label: 'aging' },
                { key: 'shipped', label: 'shipped' },
                { key: 'pre_total', label: 'total_aprox' },
                { key: 'approved', label: 'status' },
                { key: 'total', label: 'total' },
            ],
            actions: [
                { tooltip: 'file', icon: 'FileIcon',  permissions:['IU PREEXPENSES VIEW'], customClass: 'custom-primary', hideIf: row => row.approved == '0', onClick: row => this.$emit('showFile', row) },
                { tooltip: 'approve', icon: 'CheckSquareIcon', permissions:['IU PREEXPENSES APPROVED'], customClass: 'custom-success', hideIf: row => row.approved == '1', onClick: row => this.$emit('approve', row) },
                { tooltip: 'edit', icon: 'EditIcon', permissions:['IU PREEXPENSES EDIT'], customClass: 'custom-warning', hideIf: row => row.approved == '1', onClick: row => this.$emit('edit', row) },
                { tooltip: 'delete', icon: 'TrashIcon', permissions:['IU PREEXPENSES EDIT'], customClass: 'custom-danger', hideIf: row => row.approved == '1', onClick: row => this.$emit('delete', row) },

            ],
            headerActitonStyle: { width: '10vw' }
        }
    },
    methods: {
        formatCurrency,
        renderDate,
    }
}
</script>

<style></style>